// extracted by mini-css-extract-plugin
export default {"testSearch":"_1CWVgkCczoLGlB8HWN6-4L","text-map":"_1bA9lKpLMsZsCrNF1UilOV","col-lg-8":"_2hOzHcuVSAwg0gM7ss1QIj","col-lg-4":"Is5LbcLYf5W8J7bxLdfi5","button":"_1DVbrSSX2HHBaGTnGNjOQX"};